import React, { useState, useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { Link } from "gatsby";
import Img from "gatsby-image";

const MainFeature = () => {
  const imgQuery = useStaticQuery(graphql`
    query {
      allFile(filter: { relativeDirectory: { eq: "banner" } }) {
        edges {
          node {
            name
            relativeDirectory
            childImageSharp {
              fluid(maxWidth: 1028) {
                ...GatsbyImageSharpFluid_withWebp_tracedSVG
              }
            }
          }
        }
      }
    }
  `);
  const [imgState, setImg] = useState(null);
  const [mdState, setMd] = useState(null);

  useEffect(() => {
    let banner = 0;
    setImg(banner);
    setInterval(() => {
      if (
        banner ===
        imgQuery.allFile.edges.filter(
          (edge) => edge.node.name.indexOf("md") === -1
        ).length -
          1
      ) {
        banner = 0;
      } else {
        banner++;
      }
      setImg(banner);
    }, 5000);

    let mdBanner = 0;
    setMd(mdBanner);
    setInterval(() => {
      if (
        mdBanner ===
        imgQuery.allFile.edges.filter(
          (edge) => edge.node.name.indexOf("md") > -1
        ).length -
          1
      ) {
        mdBanner = 0;
      } else {
        mdBanner++;
      }
      setMd(mdBanner);
    }, 5000);
  }, [imgQuery]);

  return (
    <div className="mt-2 relative h-96 container mx-auto">
      <div className="hidden sm:block">
        {imgQuery.allFile.edges
          .filter((edge) => edge.node.name.indexOf("md") === -1)
          .map((edge, index) => (
            <Link to="/produtos" key={index}>
              <Img
                objectFit="cover"
                className={
                  imgState === index
                    ? "h-96 absolute w-full transition duration-1000 ease-in-out"
                    : "h-96 absolute w-full transition duration-1000 ease-in-out opacity-0"
                }
                fluid={edge.node.childImageSharp.fluid}
                alt="Logo de Ekobé"
              />
            </Link>
          ))}
      </div>
      <div className="block sm:hidden">
        {imgQuery.allFile.edges
          .filter((edge) => edge.node.name.indexOf("md") > -1)
          .map((edge, index) => (
            <Link to="/produtos" key={index}>
              <Img
                objectFit="cover"
                className={
                  mdState === index
                    ? "h-96 absolute w-full transition duration-1000 ease-in-out"
                    : "h-96 absolute w-full transition duration-1000 ease-in-out opacity-0"
                }
                fluid={edge.node.childImageSharp.fluid}
                alt="Logo de Ekobé"
              />
            </Link>
          ))}
      </div>
    </div>
  );
};

export default MainFeature;
